import {
  CreateReducer,
  CreateAction,
} from '../utils/store'

import {
  handlers,
} from '../utils/api'

import ENV from '../../../utils/globalEnv'

import {
  SystemState,
  ReducerHandler,
} from '../../../types/frontend/store'

import {
  ThunkHandler,
} from '../../../types/frontend/store_generic'

const prefix = 'system'

/*

  initial state

*/
const initialState: SystemState = {
  initialised: false,
  persistedRouteParams: {},
}

/*

  reducers

*/
const setInitialised: ReducerHandler<SystemState, boolean> = (state, action) => {
  state.initialised = action.payload
}

const setPersistedRouteParams: ReducerHandler<SystemState, {
  name: string,
  params: Record<string, string>,
}> = (state, action) => {
  const {
    name,
    params,
  } = action.payload
  state.persistedRouteParams[name] = params
}

const clearPersistedRouteParams: ReducerHandler<SystemState, {
  name: string,
}> = (state, action) => {
  const {
    name,
  } = action.payload
  delete(state.persistedRouteParams[name])
}


/*

  thunks

*/
const initialise: ThunkHandler<void, void> = () => async (dispatch, getState) => {
  const env = await handlers.get<any>('/env')
  Object.keys(env).forEach(name => {
    ENV[name] = env[name]
  })
  dispatch(actions.setInitialised(true))
}

/*

  collections

*/
const reducers = {
  setInitialised,
  setPersistedRouteParams,
}

export const actions = {
  setInitialised: CreateAction(prefix, `setInitialised`, setInitialised),
  setPersistedRouteParams: CreateAction(prefix, `setPersistedRouteParams`, setPersistedRouteParams),
  clearPersistedRouteParams: CreateAction(prefix, `clearPersistedRouteParams`, clearPersistedRouteParams),
  initialise,
}

export const reducer = CreateReducer<SystemState>({
  prefix,
  initialState,
  reducers,
})

export default actions
